import APIClient from '@/clients/_helpers/client'
import URLs from '@/clients/_urls'

class UserListAPI extends APIClient {
  getErrorMessage(error) {
    const errorToMessage = {
      no_owner_role_user: 'オーナー権限は最低1ユーザ必要です。',
      cannot_change_owner:
        'オーナー権限のユーザの権限変更はオーナー権限以外ではできません。',
      duplicate_user_code: 'ユーザコードが重複しています。',
    }
    if (error in errorToMessage) {
      return errorToMessage[error]
    } else {
      return '予期せぬエラーが発生しました。'
    }
  }

  async put(token, data) {
    const payload = {
      data,
      url: URLs.USER_LIST,
      method: 'PUT',
      headers: {
        Authorization: token,
      },
    }
    try {
      const response = await this.sendRequest(payload)
      if ('error' in response.data) {
        throw new Error(this.getErrorMessage(response.data.error))
      }
      return response.data
    } catch (err) {
      throw this.createResponseError(err)
    }
  }
}

export default new UserListAPI()
